import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { getDateTime } from '../../helpers/DateTime';

const DownloadRequestEditHeader = ({ downloadRequest }) => {
  const intl = useIntl();

  return (
    <header className="page-header">
      <h2 className="page-title">
        <i className="far fa-cart-arrow-down" />
        {intl.formatMessage(
          { defaultMessage: 'Download request {date}' },
          { date: getDateTime(downloadRequest.created_at) },
        )}
      </h2>
    </header>
  );
};

DownloadRequestEditHeader.propTypes = {
  downloadRequest: PropTypes.object.isRequired,
};

export default DownloadRequestEditHeader;
